export const PageHeaderContainerTheme = {
  baseStyle: {
    marginTop: '-16px',
    marginX: '-28px',
    paddingTop: '24px',
    paddingX: '28px',
    paddingBottom: '24px',
    backgroundColor: 'white',
  },
}
